import React from "react";

const About = () => {
  return (
    <section
      id="about"
      className="mb-16 scroll-mt-16 md:mb-24 lg:mb-36 lg:scroll-mt-24"
      aria-label="About-me"
    >
      <div className="sticky top-0 z-20 mx-0 mb-4 md:w-screen sm:w-full bg-zinc-900/75 px-6 py-5 backdrop-blur md:-mx-12 md:px-12 lg:relative lg:top-auto lg:mx-auto lg:w-full lg:px-0 lg:py-0 lg:opacity-0">
        <h2 className="text-sm font-bold uppercase tracking-widest text-slate-200">
          About
        </h2>
      </div>
      <div>
        <p className="mb-4">
          I'm a full-stack software developer who likes owning a product from the first specification to production. Today I'm the founding engineer of an early-stage wellbeing platform for neurodivergent adults, where I designed and built the backend API, now in production, including token-based authentication, column-level encryption for sensitive data and GDPR consent tracking.
        </p>
        <p className="mb-4">
          I work mostly with TypeScript, React, React Native and Ruby on Rails on top of PostgreSQL, and I'm currently building a serverless user and license management API on AWS (CDK, Cognito, AppSync, Lambda, DynamoDB). I write the spec before the code, and I use AI-assisted development with Claude Code as a deliberate part of how I work, not a shortcut.
        </p>
        <p className="mb-4">
          Before that, I helped migrate a platform from Angular to Vue 3 and TypeScript at{" "}
          <a
            href="https://darttek.com/"
            className="font-medium text-slate-200 hover:text-teal-300 focus-visible:text-teal-300"
            target="_blank"
            rel="noreferrer"
          >Darttek</a>, built features and PDF invoicing at{" "}
          <a
            href="https://www.aohostels.com/en/"
            className="font-medium text-slate-200 hover:text-teal-300 focus-visible:text-teal-300"
            target="_blank"
            rel="noreferrer"
          >a&o Hostels</a>, and wrote a Python feature at{" "}
          <a
            href="https://drsmile.de/drsmilexplusdental/"
            className="font-medium text-slate-200 hover:text-teal-300 focus-visible:text-teal-300"
            target="_blank"
            rel="noreferrer"
          >PlusDental</a>{" "}
          that made a quality-management workflow 80% more efficient.
        </p>
        <p>
          I came to software after more than ten years in project management, including leading teams at the{" "}
          <a
            href="http://www.theatromunicipal.org.br/pt-br/"
            className="font-medium text-slate-200 hover:text-teal-300 focus-visible:text-teal-300"
            target="_blank"
            rel="noreferrer"
          >Theatro Municipal de São Paulo</a>. That background shows up in how I work: clear priorities, honest communication and a strong sense of ownership. I speak English, French and Portuguese, and I'm based in the Netherlands.
        </p>
      </div>
    </section>
  );
};
export default About;
